import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsSummaryRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-summary',
	path: '/plugins/servlet/project-config/:projectKey/summary',
};
